import defaultValues from "@/constant/defaultValues";
import { isEmpty, lowerCase } from "lodash";
import { useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const RoadFreight = (props) => {
  const { TERM_LIST, ROAD_TYPE } = defaultValues;
  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  const {
    errors,
    styleError,
    formData,
    handleFocusOut,
    handleChange,
    handleCountryFromChange,
    handleCountryToChange,
    handleTermChange,
    showPickupAddress,
    showDeliveryAddress,
    countries,
    selectedTerm,
    selectedCountryFrom,
    selectedCountryTo,
    handlePortOfOriginChange,
    handleOriginPortInputChange,
    portOfOriginList,
    selectedPortOfOrigin,
    validatePortInput,
    originLoader,
    selectedOceanType,
    handleOceanTypeChange,
    destinationLoader,
    handlePortOfDestinationChange,
    handleDestinationPortInputChange,
    portOfDestinationList,
    selectedPortOfDestination,
  } = props;

  return (
    <>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
        <div
          className={`input-wrape select-wrape ${errors.ocean_type ? "error-show" : ""}`}
          style={{
              position: "relative",
              zIndex: openMenuIndex === "cargo" ? 10 : 1
            }}
        >
          <div className="input-pad select-wrape">
            <Select
              name="ocean_type"
              options={ROAD_TYPE}
              value={selectedOceanType}
              onChange={handleOceanTypeChange}
              placeholder="Select cargo type *"
              className="select"
              noOptionsMessage={() => "No cargo type Found"}
              onBlur={handleFocusOut}
              classNamePrefix={"Drop-down-menu"}
              onMenuOpen={() => setOpenMenuIndex("cargo")}
              onMenuClose={() => setOpenMenuIndex(null)}
            />
            {errors.ocean_type && (
              <span className="invalid-feedback" style={styleError}>
                {errors.ocean_type}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="col-xxl-12">
        <hr className="mt-0" />
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape select-wrape ${errors.country_from ? "error-show" : ""}`}
          style={{
            position: "relative",
            zIndex: openMenuIndex === "country" ? 10 : 1
          }}
        >
          <div className="input-pad select-wrape">
            <Select
              name="country_from"
              options={countries}
              value={selectedCountryFrom}
              onChange={handleCountryFromChange}
              placeholder="Select origin country"
              className="select"
              onBlur={handleFocusOut}
              noOptionsMessage={() => "No Country Found"}
              classNamePrefix={"Drop-down-menu"}
              onMenuOpen={() => setOpenMenuIndex("country")}
              onMenuClose={() => setOpenMenuIndex(null)}
            />
            {errors.country_from && (
              <span className="invalid-feedback" style={styleError}>
                {errors.country_from}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape ${errors.port_of_origin ? "error-show" : ""}`}
          style={{
            position: "relative",
            zIndex: openMenuIndex === "port1" ? 10 : 1
          }}
        >
          <div className="input-pad">
             <input
              type="text"
              name="port_of_origin"
              value={formData.port_of_origin}
              className="input"
              autoComplete="off"
              placeholder={`Enter origin port`}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />

            {errors.port_of_origin && (
              <span className="invalid-feedback" style={styleError}>
                {errors.port_of_origin}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape select-wrape ${errors.country_to ? "error-show" : ""}`}
          style={{ zIndex: "9" }}
        >
          <div className="input-pad select-wrape">
            <Select
              name="country_to"
              options={countries}
              value={selectedCountryTo}
              onChange={handleCountryToChange}
              placeholder="Select destination country"
              className="select"
              noOptionsMessage={() => "No Country Found"}
              onBlur={handleFocusOut}
              classNamePrefix={"Drop-down-menu"}
            />
            {errors.country_to && (
              <span className="invalid-feedback" style={styleError}>
                {errors.country_to}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape select-wrape ${errors.port_of_destination ? "error-show" : ""}`}
          style={{ zIndex: "8" }}
        >
          <div className="input-pad">
            <input
              type="text"
              name="port_of_destination"
              value={formData.port_of_destination}
              className="input"
              autoComplete="off"
              placeholder={`Enter destination port`}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />

            {errors.port_of_destination && (
              <span className="invalid-feedback" style={styleError}>
                {errors.port_of_destination}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div className={`input-wrape ${errors.commodity ? "error-show" : ""}`}>
          <div className="input-pad">
            <input
              type="text"
              name="commodity"
              value={formData.commodity}
              className="input"
              autoComplete="off"
              placeholder="Enter commodity *"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.commodity && (
              <span className="invalid-feedback" style={styleError}>
                {errors.commodity}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div className={`input-wrape ${errors.hs_code ? "error-show" : ""}`}>
          <div className="input-pad">
            <input
              type="text"
              name="hs_code"
              value={formData.hs_code}
              className="input"
              autoComplete="off"
              placeholder="Enter Hs Code"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.hs_code && (
              <span className="invalid-feedback" style={styleError}>
                {errors.hs_code}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape ${errors.no_of_containers ? "error-show" : ""}`}
        >
          <div className="input-pad">
            <input
              type="text"
              name="no_of_containers"
              value={formData.no_of_containers}
              className="input"
              autoComplete="off"
              placeholder={"No of Containers / Vehicles *"}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.no_of_containers && (
              <span className="invalid-feedback" style={styleError}>
                {errors.no_of_containers}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div className={`input-wrape ${errors.cbpp ? "error-show" : ""}`}>
          <div className="input-pad">
            <input
              type="text"
              name="cbpp"
              value={formData.cbpp}
              className="input"
              autoComplete="off"
              placeholder={"Enter containers Type/Boxes/Pallat/Packages *"}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.cbpp && (
              <span className="invalid-feedback" style={styleError}>
                {errors.cbpp}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape ${errors.total_weight ? "error-show" : ""}`}
        >
          <div className="input-pad">
            <input
              type="text"
              name="total_weight"
              value={formData.total_weight}
              className="input"
              autoComplete="off"
              placeholder="Enter total weight (kg)"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.total_weight && (
              <span className="invalid-feedback" style={styleError}>
                {errors.total_weight}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape select-wrape ${errors.term ? "error-show" : ""}`}
          style={{ zIndex: "4" }}
        >
          <div className="input-pad select-wrape">
            <Select
              name="term"
              options={TERM_LIST}
              value={selectedTerm}
              onChange={handleTermChange}
              classNamePrefix={"Drop-down-menu"}
              placeholder="Select term type"
              className="select"
              noOptionsMessage={() => "No Term Found"}
              onBlur={handleFocusOut}
            />

            {errors.term && (
              <span className="invalid-feedback" style={styleError}>
                {errors.term}
              </span>
            )}
          </div>
        </div>
      </div>
      {selectedTerm &&
        !isEmpty(selectedTerm) &&
        showPickupAddress.includes(selectedTerm.value) && (
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
            <div
              className={`input-wrape ${errors.pickup_address ? "error-show" : ""}`}
            >
              <div className="input-pad">
                <input
                  type="text"
                  name="pickup_address"
                  value={formData.pickup_address}
                  className="input"
                  autoComplete="off"
                  placeholder="Enter pickup address *"
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                />
                {errors.pickup_address && (
                  <span className="invalid-feedback" style={styleError}>
                    {errors.pickup_address}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
      {selectedTerm &&
        !isEmpty(selectedTerm) &&
        showDeliveryAddress.includes(selectedTerm.value) && (
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
            <div
              className={`input-wrape ${errors.delivery_address ? "error-show" : ""}`}
            >
              <div className="input-pad">
                <input
                  type="text"
                  name="delivery_address"
                  value={formData.delivery_address}
                  className="input"
                  autoComplete="off"
                  placeholder="Enter delivery address"
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                />
                {errors.delivery_address && (
                  <span className="invalid-feedback" style={styleError}>
                    {errors.delivery_address}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default RoadFreight;
